export default function toPercentage(value, total) {
  return value && total ? ((value / total) * 100).toFixed(0) + "%" : "0%";
}
